document.addEventListener('DOMContentLoaded', function() {
  var url = window.location.href;
  const hcThumbs = document.querySelectorAll('.media__thumb');
  if(url.indexOf('?variant') != -1){
    var hc_variant = url.split('?variant=')[1];
    hcThumbs.forEach(thumb => {
      thumb.classList.remove('is-selected');
    });
    setTimeout(function(){
      document.querySelector('.media__thumb[data-variant="'+hc_variant+'"]').click();
      document.querySelector('.media__thumb[data-variant="'+hc_variant+'"]').classList.add('is-selected');
    }, 200);
  }
});